import React, { useEffect } from "react";
import { useAppSelector } from "../../../../infra/hooks";
interface PropsValue {
  setAllActions: (data: any) => void;
}
const DTOFnfARModal = ({ setAllActions }: PropsValue) => {
  const storedAwardsAR = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredActions
  );

  useEffect(() => {
    if (storedAwardsAR) setAllActions(storedAwardsAR);
  }, []);
  return <></>;
};

export default DTOFnfARModal;
